import { COLORS } from '@/styles/tokens/colors';

export const NEW_TEMPLATE_SENTINEL = 'create';
export const DEFAULT_TEMPLATE_NAME = 'Untitled presentation template';

export const HEADER_HEIGHT_PX = 56;
export const LEFT_SIDEBAR_WIDTH_PX = 280;
export const LEFT_SIDEBAR_COLLAPSED_WIDTH_PX = 48;
export const BORDER_COLOR = COLORS.NEUTRAL_GRAY[200];
export const BORDER_COLOR_WARNING = COLORS.FUNCTIONAL.WARNING[200];
export const BORDER_COLOR_SELECTED = COLORS.NAVY[200];
export const BORDER_COLOR_WARNING_SELECTED = COLORS.FUNCTIONAL.WARNING[500];
